import React from "react";

const GallerySkeleton = ({ items = 12, height = "h-48" }) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4">
      {Array.from({ length: items }).map((_, idx) => (
        <div
          key={idx}
          className={`w-full ${height} bg-gray-300 shimmer rounded-md`}
        />
      ))}
    </div>
  );
};

export default GallerySkeleton;
